import * as React from "react"

const UserInterfaceIcon = ({ src }) => {
  return <span className="user-interface-icon" data-name={src}></span>
}

export default UserInterfaceIcon
